import React from "react";
import { Tab, Tabs } from "@blueprintjs/core";
import { routes } from "modules/common/routes";
import { Page } from "modules/common/components/page/Page";
import styles from "./TokensTabsPage.module.scss";
import { TokensStoreType } from "../models/tokens-store";
import { TokensList } from "./list/TokensList";
import { UsersAccess } from "./UsersAccess";
import { TokenType } from "../models/token";
import { withNavigation, NavigationProps, type Location } from "modules/common/components/routing/withNavigation";

class TokensTabsPageInternal extends React.PureComponent<TokensTabsPageProps & NavigationProps> {
    componentDidMount() {
        this.props.store.init();
    }

    render() {
        const { location, store } = this.props;
        const { canManageUsers } = this.props;
        const tabId = location.pathname.includes(routes.tokens.automatic)
            ? routes.tokens.automatic
            : canManageUsers && location.pathname.includes(routes.tokens.users)
              ? routes.tokens.users
              : routes.tokens.outer;

        return (
            <Page>
                <Tabs
                    className={`${styles.tabs} planr-tabs-navigation`}
                    id="TokensTabsPage"
                    onChange={this.handleTabChange}
                    selectedTabId={tabId}
                    renderActiveTabPanelOnly={true}
                >
                    <Tab
                        id={routes.tokens.outer}
                        title="Внешние"
                        panel={
                            <Panel hint="Браузеры, с которых входили из внешней сети. Подтвердить устройство сам человек может и кодом из Telegram или письма.">
                                <TokensList isAutomatic={false} store={store.outer} onTokenToggle={this.onTokenToggle} />
                            </Panel>
                        }
                    />
                    <Tab
                        id={routes.tokens.automatic}
                        title="Доверенные"
                        panel={
                            <Panel hint="Браузеры, подтверждённые автоматически: вход был из доверенной сети (Настройки приложения → доверенные сети).">
                                <TokensList isAutomatic={true} store={store.automatic} onTokenToggle={this.onTokenToggle} />
                            </Panel>
                        }
                    />
                    {/* отключение доступа к приложению - право «Настройки приложения» */}
                    {canManageUsers && (
                        <Tab
                            id={routes.tokens.users}
                            title="Пользователи"
                            panel={
                                <Panel narrow hint="Доступ к приложению целиком. Выключите переключатель — человек сразу выйдет на всех устройствах и не сможет войти, пока доступ не включат.">
                                    <UsersAccess active={true} />
                                </Panel>
                            }
                        />
                    )}
                </Tabs>
            </Page>
        );
    }

    handleTabChange = (tabId: string) => this.props.navigate(tabId);

    onTokenToggle = (token: TokenType, state: boolean) => {
        token.setConfirmed(state);
    };
}

interface TokensTabsPageProps {
    location: Location;
    store: TokensStoreType;
    canManageUsers: boolean;
}

export const TokensTabsPage = withNavigation(TokensTabsPageInternal);

/** Вкладка с подсказкой сверху: что здесь редактируется */
const Panel = ({ hint, narrow, children }: { hint: string; narrow?: boolean; children: React.ReactNode }) => (
    <div className={styles.panel}>
        {/* narrow - таблица пользователей не на всю ширину, подсказка по ней */}
        <div className={`${styles.hint} ${narrow ? styles.hintNarrow : ""}`}>{hint}</div>
        {children}
    </div>
);
